/**
 *
 * @notice DomaModalSlice to handle state of DomaModal globally.
 *
 * @dev This module contains the reducer configuration and its initialization.
 * @dev Is the sucker wich contains features of this slice.
 *
 */

// Redux.
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
// Axios.
import axios from "axios"
// gmapi.
import { API_KEY, caricaDomaAPI } from "../../../../common/gmApi"
// cookie.
import { tkbox, getCookie } from "../../../../common/cookie"

/********************************************
 *                                          *
 * @notice AsyncThunk API(s) Implementation *
 *                                          *
 ********************************************/

/**
 *
 *  @dev Upload a new doma.
 *
 */
export const uploadDoma = createAsyncThunk(
    // Action route.
    "doma/uploadDoma",
    /**
     * 
     * @dev Async Function with axios http req.
     * 
     * @param { string } data
     * @param { string } scadenza
     * @param { string } allegato
     *  
     * @param { AsyncThunkPayloadCreator } thunkAPI
     * @dev `thunkAPI` callback function that should return a promise
     * @dev handle with extraReducers to update the State.
     * @dev It takes two parameter too: first is the value of the dispatched action,
     * @dev and the second is the Thunk API config.
     * 
     * @returns AsyncThunk
     * 
     */
    async ({ data, scadenza, allegato }, thunkAPI) => {
        try {
            const bodyFormData = new FormData()
            bodyFormData.append('allegato', allegato, (allegato.name ? allegato.name : 'file'))
            const response = await axios.post(
                // url.
                caricaDomaAPI,
                // body.
                bodyFormData,
                // Queryparams.
                {
                    params: {
                        apikey: API_KEY,
                        tkbox: getCookie(tkbox),
                        data: data,
                        scadenza: scadenza,
                    },
                }
            )

            if (response.status === 200 && response.data.gmapi.auth === "ok") {
                if (response.data.gmapi.response.status === "ok") {
                    //return console.log(response.data);
                    return response.data
                } else {
                    // else reject gmapi response error.
                    //console.error('Error "showEmployeeCourseDocById":',response.data.gmapi.response.error[0])
                    return thunkAPI.rejectWithValue(response.data.gmapi.response.error[0])
                }
            } else {
                //console.error('Error "uploadDoma":',response.data.gmapi.error)
                return thunkAPI.rejectWithValue(response.data.gmapi.error)
            }
        } catch (error) {
            // If something get wrong then reject the error.
            console.error('Error "uploadDoma":', error.message)
            return thunkAPI.rejectWithValue(error.message)
        }
    }
)

/*******************************************
 *                                         *
 * @notice createSlice implementation.     *
 *                                         *
 * @dev Create a "domaModalSlice" feature. *
 * @dev UI views state controller.         *
 *                                         *
 *******************************************/
export const domaModalSlice = createSlice({
    // Name, used in action types.
    name: "domaModal",
    // The initial state for the reducer.
    initialState: {
        modalIsOpen: false,     // Modal is open or not.
        modalIsFetching: false, // AsyncThunk is calling an API.
        modalIsSuccess: false,  // AsyncThunk is success from API call.
        modalIsError: false,    // AsyncThunk is fail from API call.
        modalErrorMsg: "",      // Error message container.
    },
    // Reducers, an object of "case reducers".
    // Key names will be used to generate actions.
    reducers: {
        /**
         * @action clearState
         */
        clearState: (state) => {
            state.modalIsError = false
            state.modalIsSuccess = false
            state.modalIsFetching = false

            return state
        },
        /**
         * @action openModal
         */
        openModal: (state) => {
            state.modalIsOpen = true
        },
        /**
         * @action closeModal
         */
        closeModal: (state) => {
            state.modalIsOpen = false
        },
    },
    // AsyncThunk Reducers.
    // A "builder callback" function used to add more reducers, or
    // an additional object of "case reducers", where the keys should be other
    // action types.
    extraReducers: (builder) => {
        builder
            /**
             * @dev uploadDoma.
             */
            .addCase(uploadDoma.fulfilled, (state) => {
                state.modalIsFetching = false
                state.modalIsSuccess = true
            })
            .addCase(uploadDoma.pending, (state) => {
                state.modalIsFetching = true
            })
            .addCase(uploadDoma.rejected, (state, action) => {
                state.modalIsFetching = false
                state.modalIsError = true
                state.modalErrorMsg = action.payload
            })
    },
})

// Export the reducer.
export const { clearState, openModal, closeModal } = domaModalSlice.actions

// Export the Slice by name.
export const domaModalSelector = (state) => state.domaModal
